import { runAction } from '../client';
import { EntitySearchResult } from "../Search";

type Action = ApplyTagsAction | RemoveTagsAction | MoveToTimezoneAction | SetPressureLevelsAction | SetTemperatureLevelsAction;

export interface GroupActionRequest
{
    Vehicle: VehicleGroupActionParam;
    // ServiceAccount: ...
    // Sensor: ...
    // Person: ...
}

export interface VehicleGroupActionParam
{
    Ids: number[];
    Actions: Action[];
}

export interface ApplyTagsAction
{
    ApplyTags: string[];
}

export interface RemoveTagsAction
{
    RemoveTags: string[];
}

export interface MoveToTimezoneAction
{
    MoveToTimezone: number;
}

export interface SetPressureLevelsAction
{
    SetPressureLevels: PressureLevels;
}

export interface PressureLevels
{
    Axle: number;
    Baseline: number;
    DefineAlertLevels: boolean;
    RelLevelMaximumRed: number;
    RelLevelMinimumRed: number;
    RelLevelMaximumYellow: number;
    RelLevelMinimumYellow: number;
    UnitId: number;
}

export interface SetTemperatureLevelsAction
{
    SetTemperatureLevels: TemperatureLevels;
}

export interface TemperatureLevels
{
    Axle: number;
    AbsLevelMaximumRed: number; 
    AbsLevelMinimumRed: number;
    AbsLevelMaximumYellow: number;
    AbsLevelMinimumYellow: number;
    UnitId: number;
}

export interface GroupActionsFn
{
    (request: GroupActionRequest): Promise<EntitySearchResult>;
}

export const groupActions: GroupActionsFn = (request: GroupActionRequest): Promise<EntitySearchResult> => {
    if(request == null)
        throw new Error('request param has to have a value');
    
    return runAction<EntitySearchResult>('/action/GroupAction', request);
}


// WEBPACK FOOTER //
// ./src/rest/GroupAction/index.ts